import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Anchor } from "hesus-ui-kit";
import {
  QuoteItemsContainer,
  Separator,
  GridRow,
  EnquiryIdHyphen,
  GridSubLabel,
} from "../../QuoteList.styled";
import "../../QuoteList.scss";
import QuoteItems from "./QuoteItems";

const QuoteServices = (props) => {
  const { t, quoteService, quoteCurrency, quotIds, quotId } = props;

  return (
    <>
      <QuoteItemsContainer
        display={quotIds.indexOf(quotId) !== -1 ? "block" : "none"}
      >
        {quoteService?.services?.length > 0 &&
          quoteService?.services.map((service, serviceIndex) => {
            return (
              <div key={`quote-items-` + serviceIndex}>
                <Separator />
                <GridRow
                  marginBottom="10px"
                  marginTop="0px"
                  column="auto auto 1fr"
                  gap=".25rem"
                >
                  <Anchor
                    color="#0A4986"
                    fontStyle="normal"
                    weight="700"
                    url={`/site/view/${quoteService?.site?.id}/enquiry-view-${service?.sellingPrice?.requestId}`}
                    target="_blank"
                    className="quote-listing__service-link"
                  >
                    {t("ENQUIRY") + " #" + service?.sellingPrice?.requestId}
                  </Anchor>
                  <EnquiryIdHyphen
                    color="#0A4986"
                    decoration="none"
                    weight="700"
                  >
                    {" "}
                    -{" "}
                  </EnquiryIdHyphen>
                  <GridSubLabel fontSize="16px">{service?.label}</GridSubLabel>
                </GridRow>
                <QuoteItems
                  enquiryId={service.sellingPrice.enquiryId}
                  sellingPriceId={service.sellingPriceId}
                  itemList={service.items}
                  currency={service.sellingPrice?.currency}
                />
              </div>
            );
          })}
      </QuoteItemsContainer>
    </>
  );
};

QuoteServices.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(QuoteServices);
